// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3zlNG","upload":"Small_upload__1CHMV","imageWrap":"Small_imageWrap__2rpev","removeBtn":"Small_removeBtn__2umAG"};